import {
  Box,
  formatAmount,
  NonGradientTextTokens,
} from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import SessionHistoryListItemRow from '../SessionHistoryListItemRow/SessionHistoryListItemRow';
import { SessionItem } from '../../state/sessionHistory/sessionHistory.types';
import {
  formatDate,
  SHORT_DATE,
  SHORT_TIME,
} from '@bonanza-social/toolkit/utils';

function SessionHistoryListItem({
  loginDateTime,
  logoutDateTime,
  loginBalance,
  logoutBalance,
  totalBets,
  totalWins,
  netPosition,
}: SessionItem) {
  const { netAmount, netColor } = useMemo((): {
    netAmount: string;
    netColor?: NonGradientTextTokens;
  } => {
    if (netPosition === undefined) {
      return {
        netAmount: '---',
      };
    }

    const amount = formatAmount(netPosition);

    if (netPosition > 0) {
      return { netAmount: `+${amount}`, netColor: 'darkSurfaceSuccess' };
    }

    if (netPosition < 0) {
      return { netAmount: amount, netColor: 'darkSurfaceError' };
    }

    return { netAmount: amount };
  }, [netPosition]);

  return (
    <Box gap="space-300">
      <SessionHistoryListItemRow
        labelKey="sessionLogin"
        valueA={formatDate(loginDateTime, SHORT_DATE)}
        valueB={formatDate(loginDateTime, SHORT_TIME)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLogout"
        valueA={logoutDateTime ? formatDate(logoutDateTime, SHORT_DATE) : '---'}
        valueB={logoutDateTime ? formatDate(logoutDateTime, SHORT_TIME) : '---'}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLoginBalance"
        valueA={formatAmount(loginBalance)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionLogoutBalance"
        valueA={formatAmount(logoutBalance)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionTotalBets"
        valueA={formatAmount(totalBets)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionTotalWins"
        valueA={formatAmount(totalWins)}
      />
      <SessionHistoryListItemRow
        labelKey="sessionNetGaming"
        valueA={netAmount}
        valueAColor={netColor}
        accent
      />
    </Box>
  );
}

export default memo(SessionHistoryListItem);
